import { useSubmit } from "@certn/api";
import { BasicButton, GhostButton } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  item: { id: any };
  mutate: any;
  isDisabled?: boolean;
}

export function DismissTaskButton(props: Props) {
  const { t } = useTranslation();

  const { submit, isSubmitting } = useSubmit(
    `/api/internal/client-portal/tasks/dismiss/${props.item.id}/`,
    {
      showToastOnError: true,
      onSuccess: props.mutate,
    }
  );

  return (props?.isDisabled ?? false) === false ? (
    <GhostButton
      onPress={() => {
        submit();
      }}
      isLoading={isSubmitting}
      isDisabled={props.isDisabled}
      size="small"
      testID="task-dismiss-button"
    >
      {t("Dismiss")}
    </GhostButton>
  ) : (
    <BasicButton
      onPress={submit}
      isLoading={isSubmitting}
      isDisabled
      size="small"
      testID="task-dismiss-button"
    >
      {t("Dismiss")}
    </BasicButton>
  );
}
